import { useState } from 'react';
import './App.css';
import catalogue from './CompleteList.json';
import AudioPlayer from './player';

function App() {
  const [cabinetState, setCabinetState] = useState(false);

  //                 Collect The Titles                  //
  const artistAlbumKeys = Array.from(new Set(catalogue.map((item) => (item["artist"] + '-' + item["album"]))));

  const [albumSelection, setAlbumSelection] = useState(artistAlbumKeys[0]);


  //   Catalogue All The Albums and sort them   //
  let artistBins = {};
  let artistAlbumTracks = {};
  catalogue.forEach(AlbumSorter);

  function AlbumSorter(value) {
    let currentArtist = value.artist;
    let currentAlbum = value.album;
    let currentAlbumCover = value.artistFolder + '/' + value.albumFolder + '/' + value.cover;
    let currentArtistAlbumKey = (value.artist + '-' + value.album);
    let currentTrackDetails = { 
      "track":value.track, 
      "song":value.song, 
      "artist":value.artist, 
      "album":value.album, 
      "location": (value.artistFolder + '/' + value.albumFolder), 
      "file":value.file, 
      "cover":value.cover 
    };
    if (!artistBins[currentArtist]) {
      artistBins[currentArtist] = [];
    } else if (!artistBins[currentArtist][currentArtistAlbumKey]) {
      artistBins[currentArtist][currentArtistAlbumKey] = [currentAlbum, currentAlbumCover, value.albumFolder];
    }
    if (!artistAlbumTracks[currentArtistAlbumKey]) {
      artistAlbumTracks[currentArtistAlbumKey] = [];
    }
    artistAlbumTracks[currentArtistAlbumKey].push(currentTrackDetails);
  }

  const albumSelected = (selection) => {
      setAlbumSelection(selection);
      setSongSelection(0);
      if (selection) {
          setCabinetState(false);
      }
  };

  const cabinetChange = () => {
    if (cabinetState) {
      setCabinetState(false);
    } else {
      setCabinetState(true)
    }
  };

  const playerSongList = artistAlbumTracks[albumSelection];

  const [songSelection, setSongSelection] = useState(0);

  const playThis = (songNumber) => {
    setSongSelection(songNumber)
  }

  return (
    <>
      <div className="App">
        <header className="App-header">
          <h2>Dang Blasted Cranks</h2>
        </header>
      </div>
      <div className="system">
        <div className="album-selector">
          <div className="cabinet-controller">
              <button id="cabinet-latch" onClick={cabinetChange}>Album Selector</button>
          </div>
          {cabinetState && 
          <div id="album-cabinet">
              {Object.keys(artistBins).sort().map((artist) => (            
                  <div className="artist" key={artist.trim()}>
                      <div className="artist-albums">
                          {Object.keys(artistBins[artist]).map((album) => 
                                  <div key={album.trim()} className="album-display">
                                      <img className="thumbnail" src={`./music/${artistBins[artist][album][1]}`} alt="Album cover" onClick={() => albumSelected(album)}/>
                                      <p>
                                          {artistBins[artist][album][0]}<br/>
                                          <small>{artistBins[artist][album][2]}</small>
                                      </p>
                                  </div>
                              )
                          }
                      </div>
                  </div>
              ))}
          </div>}
        </div>
        <div className="media-player">
          <AudioPlayer {...{ artistAlbumKeys, albumSelection, setAlbumSelection, songSelection, setSongSelection, playerSongList }}/>
        </div>
        <div className="songListDisplay">
          <div className="playlist">
              <h2>{albumSelection.replace("-", " - ")}</h2>
              <ul id="song-list">
                  {playerSongList.map((track, index) => <li key={track.song} onClick={() => playThis(index)}>{track.track} - {track.song}</li>)}
              </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
